import React from 'react';
import { Table, Divider, List, Message, Menu, Icon, Dimmer, Loader, Dropdown, Label, Button } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import _ from 'underscore';
import Moment from 'moment';

const SysadminAdminListTable = (props) => {
    const paginationInfo = `${(props.perPage*props.currentPage)-props.perPage+1}-${(props.perPage*props.currentPage)>props.totalData ? props.totalData : (props.perPage*props.currentPage)} of ${props.totalData}`
    let data = []
    if(props.users.length > 0){
        for(let i=0 ; i < props.users.length ; i++){
            let objectToAdd = {}
            objectToAdd.uuid = props.users[i].uuid
            objectToAdd.nric = props.users[i].nric.toUpperCase()
            objectToAdd.name = props.users[i].name
            objectToAdd.email = props.users[i].email
            objectToAdd.roles = props.users[i].roles
            objectToAdd.status = props.users[i].status
            objectToAdd.companyName = props.users[i].companyName
            objectToAdd.effectiveStartDate = props.users[i].effectiveStartDate ? Moment(props.users[i].effectiveStartDate).format('DD/MM/YYYY') : '-'
            objectToAdd.effectiveEndDate = props.users[i].effectiveEndDate ? Moment(props.users[i].effectiveEndDate).format('DD/MM/YYYY') : '-'
            objectToAdd.memberType = props.users[i].memberType === 'e' ? 'Employee' : 'Dependent'
            objectToAdd.noDependant = props.users[i].memberType === 'e' ? props.users[i].family.length : '-'
            objectToAdd.roleNeeded = 1
            objectToAdd.isDefault = true
            data.push(objectToAdd)
        
        }
    }
    console.log("check data", data)
    
    return (
        <Dimmer.Dimmable>
            <Dimmer active={props.isLoading} inverted>
                <Loader/>
            </Dimmer>
            <Table celled structured>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>ID</Table.HeaderCell>
                        <Table.HeaderCell>Name</Table.HeaderCell>
                        <Table.HeaderCell>Email</Table.HeaderCell>
                        <Table.HeaderCell>Roles</Table.HeaderCell>
                        <Table.HeaderCell>Action</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                { props.users.length === 0 &&
                    <Table.Body>
                    <Table.Row>
                            <Table.Cell colSpan={8} textAlign="center">
                                <Message info>
                                    No user data.
                                </Message>
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>    
                }
                { props.users.length !== 0 &&
                    <Table.Body>
                        {_.map(data, (user) => {
                            console.log(user.roles)
                            console.log(user)
                            return (
                                <Table.Row>
                                    {user.uuid && <Table.Cell rowSpan={user.roleNeeded}>
                                        <Link to={`/systemadmin/admin/update?idUser=${user.uuid}`}>{user.uuid}</Link>
                                    </Table.Cell> } 
                                    <Table.Cell rowSpan={user.roleNeeded}>{user.name}</Table.Cell>
                                    <Table.Cell rowSpan={user.roleNeeded}>{user.email}</Table.Cell>
                                    <Table.Cell rowSpan={user.roleNeeded}>
                                        {
                                            user.roles.map(role => role.type).join(", ")
                                        }
                                    </Table.Cell>
                                    {
                                        props.adminPage && user.status !== '401' &&
                                        <Table.Cell style={{width: "35px"}}>
                                            <Button
                                                type="button"
                                                style={{
                                                    marginBottom: "5px"
                                                }}
                                                color={user.status == 401 ? "green" : "red"} 
                                                onClick={
                                                    props.terminateAdmin.bind(this, user.uuid, user.status === 401 ? 100 : 401)
                                                }
                                            >
                                                {user.status === 401 ? "Activate" : "Terminate"}
                                            </Button>
                                            {
                                                user.status !== 401 && (
                                                    <Button
                                                        basic
                                                        color={user.status == 300 ? "green" : "yellow"}
                                                        type="button"
                                                        onClick={
                                                            props.terminateAdmin.bind(this, user.uuid, user.status === 300 ? 100 : 300)
                                                        }
                                                    >
                                                        {user.status === 300 ? "Unlock" : "Lock"}
                                                    </Button>
                                                )
                                            }
                                            <Button
                                                type="button"
                                                style={{
                                                    marginBottom: "5px"
                                                }}
                                                color={"red"} 
                                                onClick={()=>{
                                                    if(window.confirm('Are you sure want to delete '+user.email+'?')){
                                                        props.deleteAdmin(user.uuid);
                                                    }
                                                }}
                                            >
                                                Delete
                                            </Button>
                                        </Table.Cell>
                                    }
                                </Table.Row>
                            )
                        })}                           
                    </Table.Body>    
                }
                
                <Table.Footer>
                    <Table.Row>
                        <Table.HeaderCell colSpan='8'>
                            <Menu floated='right' pagination>
                                <Menu.Item as='a' icon onClick={props.goToPreviousPage}
                                    disabled={props.currentPage === 1}>
                                    <Icon name='chevron left'/>
                                </Menu.Item>
                                <Menu.Item>{paginationInfo}</Menu.Item>
                                <Menu.Item as='a' icon onClick={props.goToNextPage}
                                    disabled={!props.isShowNextButton}>
                                    <Icon name='chevron right'/>
                                </Menu.Item>
                            </Menu>
                            <Menu floated='right' pagination>
                                <Menu.Item>Page</Menu.Item>
                                <Dropdown scrolling item text={props.currentPage.toString()} defaultValue={props.currentPage}>
                                    <Dropdown.Menu>
                                        {[...Array(props.totalPage)].map((e, i) =>
                                            <Dropdown.Item key={i} onClick={() => props.setPage(i+1)}>{i+1}</Dropdown.Item>
                                        )}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Menu>
                            <Menu floated='right' pagination>
                                <Menu.Item>View</Menu.Item>
                                <Dropdown item text={props.perPage.toString()} defaultValue={props.perPage}>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => props.setPerPage(10)}>10</Dropdown.Item>
                                        <Dropdown.Item onClick={() => props.setPerPage(20)}>20</Dropdown.Item>
                                        <Dropdown.Item onClick={() => props.setPerPage(50)}>50</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Menu>
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Footer>
            </Table>
        </Dimmer.Dimmable>
    );
}

export default SysadminAdminListTable;